import numeral from "numeral";

export default function Money(n, d = 2) {
  return d === 2 ? numeral(n).format("0,0.00") : numeral(n).format("0,0.000");
}
